import { axios } from "../core/axios.interceptor";
const baseURL = "connector-request";

export async function addConnectorRequest(request) {
  const response = await axios.post(`${baseURL}`, request);
  return response;
}